import React from 'react';
import { LucideIcon } from 'lucide-react';

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export const EmptyState: React.FC<EmptyStateProps> = ({ icon: Icon, title, description, action }) => (
  <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
    {/* Animated icon ring */}
    <div className="relative mb-6">
      <div className="absolute inset-0 w-20 h-20 rounded-full bg-amber-500/10 animate-ping" style={{ animationDuration: '3s' }} />
      <div className="relative w-20 h-20 rounded-2xl bg-gradient-to-br from-amber-500/15 to-orange-500/10 border border-amber-500/20 flex items-center justify-center">
        <Icon size={32} className="text-amber-500/70" />
      </div>
    </div>
    <h3 className="text-lg font-bold text-gray-200 mb-2">{title}</h3>
    <p className="text-sm text-gray-500 max-w-sm leading-relaxed">{description}</p>
    {action && (
      <button
        onClick={action.onClick}
        className="mt-6 px-6 py-2.5 bg-gradient-to-r from-amber-600 to-orange-600 text-white rounded-xl font-semibold text-sm hover:from-amber-500 hover:to-orange-500 transition-all shadow-lg shadow-amber-500/20 hover:shadow-amber-500/30 hover:-translate-y-0.5"
      >
        {action.label}
      </button>
    )}
  </div>
);
